<template>
  <li>
    <div
      :class="selectedPath === parentPath + 'filler' ? 'focused' : ''"
      @click="selectNode(filler, parentPath + 'filler')"
      @mouseenter="isHover = true"
      @mouseleave="isHover = false"
    >
      <span class="node-icon q-mr-xs">
        <q-icon
          size="xs"
          name="open_with"
        />
      </span>
      <span>filler</span>
    </div>
  </li>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import {
  IFlexMessageBox,
  IFlexMessageBubble,
  IFlexMessageButton,
  IFlexMessageCarousel,
  IFlexMessageFiller,
  IFlexMessageIcon,
  IFlexMessageImage,
  IFlexMessageSeparator,
  IFlexMessageSpan,
  IFlexMessageText,
  IFlexMessageVideo,
} from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['onSelectNode', 'onHoverNode'],
})
export default class Filler extends Vue {
  @Prop()
  filler!: IFlexMessageFiller

  @Prop()
  selectedNode!: IFlexMessageCarousel | IFlexMessageBubble | IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo

  @Prop()
  selectedPath!: string

  @Prop()
  parentPath!: string

  isHover = false

  selectNode(node, path) {
    if (this.selectedNode === node && this.selectedPath === path) {
      this.$emit('onSelectNode', undefined, '')
    } else {
      this.$emit('onSelectNode', node, path)
    }
  }

  @Watch('isHover')
  onHover() {
    if (this.isHover) {
      this.$emit('onHoverNode', this.parentPath + 'filler')
    }
  }
}
</script>

<style scoped lang="scss">

</style>
